<nav class="navbar navbar-expand-lg navbar-light bg-light" *ngIf="prequalification.id">
  <span class="mr-auto">
    <button mat-raised-button class="m-1 mr-2" routerLink="../../">
      <mat-icon>arrow_back</mat-icon> Back
    </button>

    <button mat-raised-button class="m-1 mr-2" color="warn" (click)="onDelete()" *ngIf="app.account.isMasterAccount()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </span>
</nav>

<form #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="container-fluid p-0">

    <div class="card rounded-0">
      <div class="card-body">

        <div class="alert alert-info" role="alert" *ngIf="!app.account.isMasterAccount()">
          This Pre-Qualification is managed by "{{app.account.master_account.name}}".
          You can create the Pre-Qualification but will not be able to make changes to it.
          To make changes, please contact "{{app.account.master_account.name}}".
        </div>

        <div class="row">
          <div class="col-12 col-xl-5">

            <div class="card mb-4" style="max-width: 620px">
              <div class="card-body">
                <div class="card-title">
                  <h6 id="title">Pre-Qualification</h6>
                </div>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Name</mat-label>
                  <input matInput placeholder="Name"
                    [(ngModel)]="prequalification.name" name="name" type="text"
                    required #name id="name" />
                  <mat-error *ngIf="!name.valid">Please enter an Prequalification
                    Pre-Qualification Name
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Pre-Qualification Description</mat-label>
                  <textarea matInput placeholder="Pre-Qualification Description"
                    [(ngModel)]="prequalification.description" name="description"
                     #description id="description" rows="5"></textarea>
                  <mat-hint>A description that will be presented to the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} when they complete their pre-qualification.</mat-hint>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Pre-Qualification Expiry Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    placeholder="Pre-Qualification Expiry Date"
                    readonly
                    (click)="picker.open()"
                    [(ngModel)]="expiryDate"
                    name="expires_at"
                    id="expires_at"
                    [min]="currentDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker disabled="false"></mat-datepicker>

                  <button
                    type="button"
                    matSuffix
                    mat-icon-button
                    *ngIf="expiryDate"
                    (click)="onRemoveExpiryDate($event)"
                    matTooltip="Remove the Pre-Qualification Expiry Date.">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>

                <div class="full-width mb-4" *ngIf="expiryDateChanged()">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Reason for Expiry Date Change</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="prequalification.expiry_change_note"
                      name="expiry_change_note"
                      [required]="expiryDateChanged()">
                    </textarea>
                    <mat-hint>
                      This note will be included in the notification email.
                    </mat-hint>
                  </mat-form-field>
                </div>

                <div class="full-width mb-4">
                  <mat-slide-toggle
                    [(ngModel)]="prequalification.enable_notifications"
                    name="enable_notifications"
                    matTooltip="{{prequalification.enable_notifications ? 'Disable notifications for this pre-qualification' : 'Enable notifications for this pre-qualification'}}">
                    Enable Pre-Qualification Notification
                  </mat-slide-toggle>
                </div>

                <button mat-raised-button class="my-2 ml-1 mr-2" [disabled]="!form.valid || inProgress"
                  color="primary" id="save" type="submit">
                  <mat-icon>save</mat-icon>
                  Save
                </button>

                <button mat-raised-button class="my-2 ml-1 mr-2" [matMenuTriggerFor]="menu" type="button" *ngIf="templates?.length"
                  color="secondary">
                  <mat-icon>file_copy</mat-icon>
                  Copy From Template
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item *ngFor="let template of templates"
                    (click)="onSelectTemplate(template)">
                    {{ template.name }}
                  </button>
                </mat-menu>

              </div>
            </div>

          </div>
          <div class="col-12 col-xl-7">
            <div class="row">
              <div class="col-12">
                <h6>Selectable Pre-Qualification Documents</h6>
              </div>
              <div class="col-12 col-lg-6 col-xl-4" *ngFor="let item of items; let i = index">
                <mat-checkbox (change)="onToggleItem(item.id)" [checked]="isItemSelected(item.id)">{{ item.name }}</mat-checkbox>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
